"use client";

import gql from "graphql-tag";
import type { GeneratedMutation, GraphQLResult } from "@aws-amplify/api-graphql";
import type { GeneralResponse } from "@rmh/defs";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";

interface SetSelfPayPayerMutationData {
  setSelfPayPayer: GeneralResponse;
}

export const setSelfPayPayerMutation = gql`
  mutation setSelfPayPayer {
    setSelfPayPayer {
      success
      message
      errorMsg
    }
  }
`.loc?.source.body as GeneratedMutation<
  Record<string, never>,
  SetSelfPayPayerMutationData
>;

/**
 * Records "Self Pay" as the patient's payer in HubSpot (via the Cognito-authed
 * GraphQL client). Patient identity is derived server-side from the verified
 * token, so no arguments are needed.
 *
 * Exposed as a plain async function so it can be called from an event handler
 * (e.g. the self-pay confirm button) rather than only via a React hook.
 */
export const requestSetSelfPayPayer = (): Promise<
  GraphQLResult<SetSelfPayPayerMutationData>
> => fetchGraphQLClient(setSelfPayPayerMutation, {});
